import { Component, OnInit, ViewChild } from '@angular/core'
import { DialogComponent } from '../../dialog/dialog.component'

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss']
})
export class ConfirmComponent implements OnInit {
  @ViewChild('dialog') dialogRef: DialogComponent

  color = 'primary'
  icon = 'info circle'
  message = ''

  constructor() { }

  ngOnInit() {}

  show () {
    return this.dialogRef.show()
  }
}
